import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2 } from "lucide-react";
import { Shell } from "./ResidenceResponse";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

function Confirmed({ at }) {
  return (
    <div className="text-center py-6" data-testid="residence-confirm-done">
      <CheckCircle2 className="w-10 h-10 text-[#4F6B4A] mx-auto" />
      <h1 className="font-serif text-3xl text-[#1A1A1A] mt-4">Réservation confirmée</h1>
      <p className="text-sm text-[#666] mt-2">Confirmée le {fmt(at)}. Le client et l'équipe matchappart ont été prévenus. Merci !</p>
    </div>
  );
}

export default function ResidenceConfirm() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/residence-confirm/${token}`)
      .then(({ data }) => setInfo(data))
      .catch((e) => setError(e.response?.status === 404 ? "Lien de confirmation invalide" : e.response?.data?.detail || "Lien invalide"));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/residence-confirm/${token}`);
      setInfo((i) => ({ ...i, confirmed_at: data.confirmed_at }));
    } catch (e) {
      setError(e.response?.data?.detail || "Confirmation impossible, réessayez");
    } finally {
      setBusy(false);
    }
  };

  if (!info) return <Shell><p className="text-sm text-[#666]" data-testid="residence-confirm-status">{error || "Chargement de la réservation…"}</p></Shell>;
  if (info.confirmed_at) return <Shell><Confirmed at={info.confirmed_at} /></Shell>;
  return (
    <Shell>
      <div className="text-xs tracking-[0.25em] uppercase font-semibold text-[#8C6C50]">Confirmation de réservation</div>
      <h1 className="font-serif text-3xl sm:text-4xl tracking-tight text-[#1A1A1A] mt-3" data-testid="residence-confirm-title">{info.label}</h1>
      {info.address && <p className="text-sm text-[#666] mt-1">{info.address}</p>}
      <dl className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm" data-testid="residence-confirm-lines">
        {info.lines.map((x) => (
          <div key={x.label}><dt className="text-[#666] text-xs">{x.label}</dt><dd className="text-[#1A1A1A] font-medium">{x.value}</dd></div>
        ))}
      </dl>
      {error && <p className="mt-4 text-sm text-[#8A3B32]" data-testid="residence-confirm-error">{error}</p>}
      <button type="button" onClick={confirm} disabled={busy} className="mt-8 w-full sm:w-auto px-8 py-3 rounded-full text-sm font-medium bg-[#4F6B4A] text-white hover:bg-[#3E5639] transition-colors disabled:opacity-50" data-testid="residence-confirm-submit">
        {busy ? "Confirmation…" : "Je confirme la réservation"}
      </button>
    </Shell>
  );
}
